import { render, staticRenderFns } from "./AccessRestricted.vue?vue&type=template&id=daf267da"
import script from "./AccessRestricted.vue?vue&type=script&lang=ts"
export * from "./AccessRestricted.vue?vue&type=script&lang=ts"
import style0 from "./AccessRestricted.vue?vue&type=style&index=0&id=daf267da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports